import { SubscriptionLayout } from './SubscriptionLayout';
import type { CompanyBillingData, CompanySubscriptionTier } from '@/types/billing';

interface CompanyBillingSectionProps {
  companyData: CompanyBillingData;
  subscriptionTiers: CompanySubscriptionTier[];
  onChangePlans: (companyData: CompanyBillingData) => void;
  onRefetchBilling?: () => Promise<void>;
  isActive?: boolean;
}

export function CompanyBillingSection({ 
  companyData, 
  subscriptionTiers,
  onChangePlans,
  onRefetchBilling,
  isActive = true
}: CompanyBillingSectionProps) {
  return (
    <SubscriptionLayout
      companyData={companyData}
      subscriptionTiers={subscriptionTiers}
      onChangePlans={onChangePlans}
      onRefetchBilling={onRefetchBilling}
      isActive={isActive}
    />
  );
}